// @ts-nocheck
import { type ApolloCache, ApolloClient } from "@apollo/client";
import {
    LenssourceGetLensSourceListRequestQuery as LensSourceListRequestQuery,
    LenssourceModelLensSourceType as LensSourceType,
} from "../../../../gql-generated/types";
import {
    getCachedLensSourceList,
    type GetCachedLensSourceListQuery,
    type GetCachedLensSourceListQueryVariables,
    getLensSourceList,
    type GetLensSourceListQuery,
    type GetLensSourceListQueryVariables,
} from "../queries";
import { LensSourcesCacheOperations } from "./LensSourcesOperations";

export class LensSourcesRepository {
    public constructor(private apolloClient: ApolloClient<any>) {}

    public static initDefaults(cache: ApolloCache<any>, lensSourceType?: LensSourceType) {
        cache.writeQuery<Partial<GetCachedLensSourceListQuery>, GetCachedLensSourceListQueryVariables>({
            query: getCachedLensSourceList,
            data: {
                __typename: "Query",
                getLensSourceList: {
                    lensSourceList: [],
                    cursor: "",
                    __typename: "LenssourceGetLensSourceListResponse",
                },
            },
            variables: {
                lensSourceType,
            },
        });
    }

    public loadLensesToCache(variables: Partial<GetLensSourceListQueryVariables>) {
        const lensesCache = this.apolloClient.readQuery<GetCachedLensSourceListQuery>({
            query: getCachedLensSourceList,
        });

        return this.apolloClient
            .query<GetLensSourceListQuery, GetLensSourceListQueryVariables>({
                query: getLensSourceList,
                variables: {
                    lensSourceType: variables.lensSourceType,
                    limit: variables.limit,
                    query: LensSourceListRequestQuery.OnlyDisabled,
                    cursor: lensesCache?.getLensSourceList.cursor,
                },
                fetchPolicy: "no-cache",
            })
            .then(({ data }) => {
                this.appendToCache(data, variables.lensSourceType);
                return data.getLensSourceList;
            });
    }

    private appendToCache(data: GetLensSourceListQuery, type: LensSourceType) {
        const prevData = this.apolloClient.readQuery<GetCachedLensSourceListQuery>({
            query: getCachedLensSourceList,
        });

        this.apolloClient.cache.writeQuery<GetCachedLensSourceListQuery, GetCachedLensSourceListQueryVariables>({
            query: getCachedLensSourceList,
            data: LensSourcesCacheOperations.concat(prevData, data),
            variables: {
                lensSourceType: type,
            },
        });
    }
}
